module.exports = __webpack_public_path__ + "static/media/pic3.dd57cf69.jpg";